import React from 'react';
import Faq from 'react-faq-component';
import Slider from '../NetflixSlider'
import {  Link } from 'react-router-dom'
import InstructordCard from '../instructor/InstructorCard';
import Objetico from '../curso/Objetivo';
import moment from 'moment';
import 'moment/locale/es';
import {
    Card,
    Item,
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
    Label,
  List,
    Icon, 
    Input,
    Button,
  Menu,
    Form, 
    Radio, 
    Transition, 
  Segment,
    Visibility
} from 'semantic-ui-react';
import RichTextEditor from 'react-rte';
moment.locale('es');


const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
      {label: 'Italic', style: 'ITALIC'},
      {label: 'Underline', style: 'UNDERLINE'}
    ],
    BLOCK_TYPE_BUTTONS: [
      {label: 'UL', style: 'unordered-list-item'},
      {label: 'OL', style: 'ordered-list-item'}
    ]
  };

const config = {
		readonly: false // all options from https://xdsoft.net/jodit/doc/
	}


const CorreoForm = ({content, curso,  user, cursoCombo, errors, strings, onChange, correos, setContent, value, onSend , inscripcionCombo}) => {
    
    //console.log(strings);
    
    return (
      <Container>
          
            <Segment>
            <Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form >
                              <Form.Field>
                              <label  >{strings?strings["Curso"]:""}</label>
                              <Dropdown
                                    style={{"z-index":"100"}}
                                    placeholder={strings?strings["Curso"]:""} 
                                    name="cursoId"
                                    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={correos.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
                    
        
                            {correos.cursoId>0?
        
                                <Form.Field>
                                  <label  >{strings?strings["Alumnos"]:""}</label>
                                  <Dropdown 
                                        style={{"z-index":"99"}}
                                        placeholder={strings?strings["Alumnos"]:""} 
                                        name="alumnoId"
                                        fluid 
                                        search 
                                        selection
                                        multiple
                                        onChange={onChange}
                                        value={correos.alumnoId}
                                        options={inscripcionCombo}/>
                                </Form.Field>

        
                            :
                                ""
                            }
        
        
                    
        
        
                        
                         </Form>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
        
        
                        <RichTextEditor
                                rootStyle={{
                                      fontFamily: 'sans-serif'
                                    }}
                                toolbarConfig={toolbarConfig}
                                value={value}
                                onChange={value=>setContent(value)}
                                placeholder="Agrega tu mensaje"
                            />
        
        
                    </Grid.Column>
                </Grid.Row>
            </Grid>
                                
              <Grid centered>

                    <Button  color="black" onClick={onSend}>
                            {strings?strings["enviar"]:"Vacio"}
                     </Button>

                </Grid>                    
                <br/>                
                                
            </Segment>

               
    </Container>    
);
}
 
export default CorreoForm;